<template>
    <div class="root-cause-analysis">
        <div style="margin-bottom: 10px" class="df both-side">
            <div></div>
            <a-button @click="handleUpdate(null)" size="small" :disabled="!actionAuthority">新增模板</a-button>
        </div>
        <a-table :data-source="table.data" bordered :pagination="false"
            :scroll="{ x: 'calc(100vw - 300px)', y: 'calc(100vh - 310px)' }" :columns="columns" rowKey="id">
            <template #repairFrequency="{ record }">
                {{ record.repairFrequency ? record.repairFrequency : '-' }}
            </template>
            <template #qualityFrequency="{ record }">
                {{ record.qualityFrequency ? record.qualityFrequency : '-' }}
            </template>

            <template #action="{ record }">
                <a-space>
                    <a-button type="primary" @click="handleUpdate(record)" size="small"
                        :disabled="!actionAuthority">修改</a-button>

                    <a-button @click="handleDelete(record)" size="small" danger
                        :disabled="!actionAuthority">删除</a-button>
                </a-space>
            </template>

        </a-table>

        <analysis-form ref="analysisFormRef" @handleUpdateTable="getData"></analysis-form>
    </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import { useTable } from "@/views/notice/serve/table"
import { getRootCauseAnalysisTemplateList, deleteRootCauseAnalysisTemplate, getRootCauseAnalysisSummary } from '@/request/view/afterSale.js';

import analysisForm from '@/views/afterSaleRepair/pc/rootCauseAnalysis/form.vue';
import { useStore } from "vuex";

export default defineComponent({
    components: {
        analysisForm
    },
    setup() {
        const analysisFormRef = ref();

        const user = useStore().state.user.user;

        const developAuthority = '工程部,研发中心'.indexOf(user.firstLevelDepartment) !== -1;

        const productAuthority = '试产中心,研发中心'.indexOf(user.firstLevelDepartment) !== -1;

        const actionAuthority = process.env.NODE_ENV === 'production' ? productAuthority : developAuthority;

        const {
            requestConfig,
            table,
            requestPayload,
            initPayload,
            getListData,
            searchData,
            deleteRecords,
        } = useTable();

        initPayload({

        });

        const columns = [
            {
                title: "报修频率",
                dataIndex: "repairFrequency",
                align: "center",
                width: "120px",
                slots: {
                    customRender: 'repairFrequency'
                },
            },
            {
                title: "质检频率",
                dataIndex: "qualityFrequency",
                align: "center",
                width: "120px",
                slots: {
                    customRender: 'qualityFrequency'
                },
            },
            // {
            //     title: "占比",
            //     dataIndex: "percent",
            //     align: "center",
            //     width: "100px",
            // },
            {
                title: "负责人",
                dataIndex: "recipient",
                align: "center",
                width: "160px"
            },
            {
                title: "根本原因",
                dataIndex: "rootCauseAnalysis",
                align: "center"
            },
            {
                title: "临时措施",
                dataIndex: "temporaryMeasures",
                align: "center"
            },
            {
                title: "闭环措施",
                dataIndex: "closedLoopMeasures",
                align: "center"
            },
            {
                title: "执行措施",
                dataIndex: "implementationMeasures",
                align: "center"
            },
            {
                title: "操作",
                dataIndex: "action",
                slots: {
                    customRender: "action"
                },
                width: "160px",
                align: "center"
            }
        ];

        requestConfig.pull_fn = getRootCauseAnalysisTemplateList;
        requestConfig.delete_fn = deleteRootCauseAnalysisTemplate;

        const handleUpdate = (record) => {
            const type = record ? 'update' : 'insert';
            const title = record ? '修改模板信息' : '新增模板';
            analysisFormRef.value.showModal(type, {
                data: record,
                title
            });
        };

        const getStatistics = () => {
            return new Promise((resolve, reject) => {
                getRootCauseAnalysisSummary().then((res) => {
                    resolve(res.data);
                }).catch((err) => {
                    reject(err)
                });
            });
        };

        const getPercent = (count, total) => `${Number((count / total) * 100).toFixed(2)}%`;

        const getData = () => {
            getListData().then(async () => {
                // const statistics = await getStatistics();
                // const total = table.data.length;
                // table.data.forEach((item) => {
                //     const count = statistics[item.id]
                //     item.percent = count ? getPercent(count, total) : 0;
                //     item.frequency = count ? count : 0;
                // });
                table.data.sort((a, b) => {
                    const bcount = b.repairFrequency + b.qualityFrequency;
                    const acount = a.repairFrequency + a.qualityFrequency;
                    return bcount - acount
                });
            });
        };

        const handleDelete = (record) => {
            deleteRecords([record.id], { title: '确认删除该条记录？' }).then(() => {
                getData();
            })
        };

        getData();

        return {
            table,
            columns,
            actionAuthority,
            analysisFormRef,
            handleDelete,
            handleUpdate,
            getData,
        };
    },
});
</script>

<style lang="less" scoped>
.root-cause-analysis {
    background: #fff;
    box-shadow: 3px 3px 8px 4px rgba(8, 26, 81, 0.04);
    padding: 20px;
    border-radius: 10px;
    height: calc(100vh - 120px);
}
</style>
